import isTouchDevice from '@/helpers/is-touch-device'

const state = {
    is_touch_device: isTouchDevice(),
}

const getters = {
    is_touch_device: state => state.is_touch_device,
}

const mutations = {}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
}
